import type {
  LibraryTemplate,
  GetLibraryRequestBody,
  CopyFromLibraryRequestBody,
  CopyFromLibraryResponse,
} from "@/common/types/templates";
import axiosClient from "@/lib/axios/axiosClient";

export const getTemplateLibrary = async (
  body: GetLibraryRequestBody = {}
): Promise<LibraryTemplate[]> => {
  const response = await axiosClient.post<LibraryTemplate[]>(
    "/get-library-templates",
    body,
    {
      sendToken: true,
      headers: {
        Accept: "application/json",
        "Content-Type": "text/plain; charset=utf-8",
      },
    }
  );

  return response.data;
};

export const getTemplateCategories = async (
  body: GetLibraryRequestBody = {}
): Promise<string[]> => {
  const response = await axiosClient.post<string[]>(
    "/get-library-templates",
    { ...body, categoriesOnly: true },
    {
      sendToken: true,
      headers: {
        Accept: "application/json",
        "Content-Type": "text/plain; charset=utf-8",
      },
    }
  );

  return response.data;
};

export const copyTemplateFromLibrary = async (
  body: CopyFromLibraryRequestBody
): Promise<CopyFromLibraryResponse> => {
  const response = await axiosClient.post<CopyFromLibraryResponse>(
    "/copy-from-library",
    body,
    {
      sendToken: true,
      headers: {
        Accept: "application/json",
        "Content-Type": "text/plain; charset=utf-8",
      },
    }
  );

  return response.data;
};
